import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { normalizeDecimal,
  renderAutoCompleteSingleSelect,
  renderTextField,  
} from '../../../../components/reduxFields';
import { getMasterData, getStaffTrainingTitleHoursForHIH, getStaffsAndPatientsByLocation, saveStaffTrainingTitleHoursForHIH } from '../../actions/UserActions';
import Alert from 'react-s-alert';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import _ from 'lodash';

const validate = (values) => {
  const errors = {};
  if (values.TrainingTitle && values.TrainingTitle.length) {
    const payrollArrayErrors = [];
    values.TrainingTitle.forEach((Obj, index) => {
      const payrollErrors = {};
      if (!Obj.trainingTitleId) {
        payrollErrors.trainingTitleId = 'Please select training title';
      }
      if (!Obj.trainingHours || parseFloat(Obj.trainingHours || 0) === 0) {
        payrollErrors.trainingHours = 'Please enter training hours';
      }
      payrollArrayErrors[index] = payrollErrors;
    });
    if (payrollArrayErrors.length) {
      errors.TrainingTitle = payrollArrayErrors;
    }
  }

  return errors;
};


class TrainingTitleHoursList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      staffId: null,
      clickedTrainingTitles: [],
    };
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleNewRequestForStaff = this.handleNewRequestForStaff.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.updateTrainingTitleHours = this.updateTrainingTitleHours.bind(this);    
    this.renderData = this.renderData.bind(this);   
  }

  loadData() {
    if (this.state.staffId)
      this.props.getStaffTrainingTitleHoursForHIH(this.state.staffId);
  }

  componentWillMount() {
    let masterData = 'SUPERVISIONTRAININGTITLE';
    this.props.getMasterData(masterData);
    let searchObj = {
      locationIds: this.props.currentLocationId || '',
      permissionKey: 'SCHEDULING_LIST_VIEW_OTHERSTAFF_SCHEDULES',
      isActiveCheckRequired: 'YES',
    };
    this.props.getStaffsAndPatientsByLocation(searchObj);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_staffTrainingTitleHours && nextProps.saved_staffTrainingTitleHours !== this.props.saved_staffTrainingTitleHours) {
      this.loadData();
    }
  }
  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  setSortColumn(sortColumn, sortOrder) {
    if (sortColumn) {
      this.filter.sortColumn = sortColumn;
      this.filter.sortOrder = sortOrder;
      this.loadData();
    }
  }

  handleNewRequestForStaff(input, selectedRecord) {
    input.onChange(selectedRecord.value);
    this.setState({ staffId: selectedRecord.value || null }, () => {
      this.loadData();
    });
  }

  updateTrainingTitleHours(formData) {
    formData.TrainingTitle.map((obj) => {
      obj.staffId = this.props.selectorStaffId;
      return obj;
    });

    let postData = formData.TrainingTitle;
    // console.log('formData..', JSON.stringify(postData));
    this.props.saveStaffTrainingTitleHoursForHIH(postData);
  }

  addRow = () => {};
  removeRow = () => {};
  renderData = ({ fields }) => {

    this.addRow = () => {
      fields.push({});
    };
    this.removeRow = (index) => {
      fields.remove(index);
    };

    if (!this.props.selectorStaffId) {
      return (
        <tbody>
          <tr>
            <td colSpan="3">
              <div className="familydl text-center no-record">No staff selected</div>
            </td>
          </tr>
        </tbody>
      );
    }
    return (
      <tbody>
        { fields.map((Obj, index) => {
          let restSelectorPayRolls = (this.props.selectorTrainingTitle || []).filter((obj, pIndex) => pIndex !== index),
            dropdownFilteredTrainingTitles = _.differenceWith(this.props.trainingTitles, restSelectorPayRolls, function(o1, o2) {
              return (o2['trainingTitleId'] === o1['id']);
            });

          let trainingTitleObj = this.props.selectorTrainingTitle && this.props.selectorTrainingTitle[index];
          let selectedIndexTrainingTitle = trainingTitleObj && trainingTitleObj.trainingTitleId;
          // let isUpdatePayRate = (clickedTrainingTitles || []).includes(trainingTitleObj && trainingTitleObj.id);
          // let isUpdateAction = (trainingTitleObj && trainingTitleObj.id) ? false : true;
          // console.log(isUpdateAction, isUpdatePayRate);
          return (
            <tr key={index}>              
              <td>
                <div className='pdt-25'>
                  <Field
                    name={`TrainingTitle[${index}].trainingTitleId`}
                    hintText='Training Title'
                    handleNewRequest={(input, selectedRecord) => this.handleNewRequest(input, selectedRecord)}
                    options= {dropdownFilteredTrainingTitles}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </td>
              <td>
                <Field
                  name={`TrainingTitle[${index}].trainingHours`}
                  hintText='Hours'
                  maxLength={10}
                  normalize={normalizeDecimal}
                  component={renderTextField}
                />
              </td>
              
              {/* <td>
                <div>
                  {(index > 0) && !selectedIndexTrainingTitle ?
                    <button className="tableless"
                      onClick={this.removeRow.bind(this, index)}
                      title="Remove row"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button> : null}

                  { (fields.length - 1) === index ?
                    <button className="tableadd" type="button" title="Add Training Title" onClick={() => this.addRow()}>
                      <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                    </button>
                    : null}
                </div>
              </td> */}

              <td>
                {fields.length === index + 1 ?
                  <div>
                    {fields.length > 1 ?
                      <button className="tableless"
                        onClick={this.removeRow.bind(this, index)}
                        title="Remove row"
                        type="button">
                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                      </button>
                    : ''}
                    <button className="tableadd" type="button" title="Add Training Type" onClick={(e) => this.addRow()}>
                      <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                    </button>
                  </div>
                  :
                  <div>
                    <button className="tableless"
                      onClick={this.removeRow.bind(this, index)}
                      title="Remove row"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  </div>
                }
              </td>
            </tr>
          );
        })
        }
      </tbody>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div className="row">
        <div className="col-sm-12">
          <h2 className="page_title">Manage Training Titles</h2>
          <div className="clearfix"></div>
          <div className="readmin-panel">
            <div className="panel-body">
              <form className="readmin-form custom_form" onSubmit={handleSubmit(this.updateTrainingTitleHours)}>
                <div className="modalwindow">
                  <div className="row">
                    <div className="col-sm-6 mt-30">
                      <Field
                        name="StaffId"
                        label="Staff"
                        handleNewRequest={this.handleNewRequestForStaff}
                        options={this.props.staffsList}
                        component={renderAutoCompleteSingleSelect}/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-responsive mt-15">
                      <table className={tableClass}>
                        <thead>
                          <tr>                            
                            <th width="40%">Training Titles</th>
                            <th width="40%">Hours</th>                            
                            <th width="20%">Action</th>
                          </tr>
                        </thead>

                        <FieldArray name='TrainingTitle' component={this.renderData} />

                      </table>
                    </div>
                    {this.props.selectorStaffId && this.props.updatePermission ?
                      <div className="row">
                        <div className="col-sm-12 pt20 btn_rt">
                          <CommonButton type="submit" primary={true} label= "Update Training Hour(s)"/>
                        </div>
                      </div>
                      : null }
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


TrainingTitleHoursList = reduxForm({
  form: 'TrainingTitleHoursListForm',
  enableReinitialize: true,
  validate,
})(TrainingTitleHoursList);

const selector = formValueSelector('TrainingTitleHoursListForm');

function mapStateToProps(state) {
  let supervisionTrainingTitle = [],
    initialValueData = {
      'StaffId': selector(state, 'StaffId'),
      'TrainingTitle': [{}],
    };
  if (state.user.master_data) {
    supervisionTrainingTitle = state.user.master_data.supervisionTrainingTitle || [];
  }
  let staffsByLocation = [];
  if (state.user.staffsAndPatientsByLocation && state.user.staffsAndPatientsByLocation.data) {
    // staffsByLocation = state.user.staffsAndPatientsByLocation.data.staff || [];
    staffsByLocation = state.user.staffsAndPatientsByLocation.data.staff || [];
  }

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "USER");
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "USER_TRAINING_TITLE_LIST" && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "USER_TRAINING_TITLE_LIST_UPDATE_HOURS")[0].permission : false;
  // End For Role Permission

  if (state.user.staffTrainingTitleHours) {
    initialValueData = {
      'StaffId': selector(state, 'StaffId'),
      'TrainingTitle': state.user.staffTrainingTitleHours.data,
    };
  }
  return {
    currentLocationId: state.login.currentLocationId,
    staffsList: staffsByLocation,
    trainingTitles: supervisionTrainingTitle,
    initialValues: initialValueData,
    selectorTrainingTitle: selector(state, 'TrainingTitle'),
    selectorStaffId: selector(state, 'StaffId'),
    saved_staffTrainingTitleHours: state.user.saved_staffTrainingTitleHours,
    updatePermission: updatePermission,
  };
}


export default connect(mapStateToProps, { getMasterData, getStaffsAndPatientsByLocation, getStaffTrainingTitleHoursForHIH, saveStaffTrainingTitleHoursForHIH })(TrainingTitleHoursList);



// WEBPACK FOOTER //
// ./src/modules/users/component/staffTrainingTitleHoursForHIH/trainingTitleHoursList.js